import * as actionTypes from '../../constants/actionTypes';

const initialState = {};

export default function(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_TASK_TYPES_ERROR:
      return action.payload;
    case actionTypes.GET_TASK_TYPES_SUCCESS:
      return action.payload.taskTypeList.map(taskType => {
        return {
          ...taskType,
          label: taskType.name,
          value: taskType.uid,
        };
      });
    default:
      return state;
  }
}
